import { NotificationActionConst } from "../Constants/NotificationConstants";

const initialState = {
  notifications: [],
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
  error: null,
  unreadCount: 0,
  fcmToken: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NotificationActionConst.FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case NotificationActionConst.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.result.notifications,
        total: action.result.total,
        page: action.result.page,
        limit: action.result.limit,
        unreadCount: action.result.notifications.filter((n) => !n.isRead).length,
      };

    case NotificationActionConst.FETCH_NOTIFICATIONS_FAIL:
      return { ...state, loading: false, error: action.error };

    case NotificationActionConst.FETCH_UNREAD_COUNT_SUCCESS:
      return { ...state, unreadCount: action.count };

    case NotificationActionConst.MARK_READ_SUCCESS: {
      if (action.all) {
        return {
          ...state,
          notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
          unreadCount: 0,
        };
      }
      const readIds = new Set(action.notificationIds || []);
      const markedCount = state.notifications.filter(
        (n) => !n.isRead && readIds.has(n.id)
      ).length;
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          readIds.has(n.id) ? { ...n, isRead: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - markedCount),
      };
    }

    case NotificationActionConst.FCM_TOKEN_REGISTERED:
      return { ...state, fcmToken: action.token };

    case NotificationActionConst.ADD_FOREGROUND_NOTIFICATION:
      return {
        ...state,
        notifications: [action.notification, ...state.notifications],
        unreadCount: state.unreadCount + 1,
        total: state.total + 1,
      };

    default:
      return state;
  }
};

export default notificationReducer;
